import styled from "styled-components";

const Text = styled.div`
  color: ${props => props.theme.darkgrey};
  font-size: 18px;
`;

export default Text;
